/**
 * Landing Page Animations
 * Fade-in on scroll using IntersectionObserver
 * Vanilla JavaScript (no Vue dependencies)
 */

export function initAnimations() {
  // Fade-in animation for elements with data-fade-in attribute
  const fadeElements = document.querySelectorAll('[data-fade-in]');

  if (fadeElements.length === 0) {
    return; // No elements to animate
  }

  // IntersectionObserver for scroll-triggered animations
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Element is visible, trigger fade-in
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-4');

          // Optionally unobserve after animation (one-time animation)
          // observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1, // Trigger when 10% of element is visible
      rootMargin: '0px 0px -50px 0px' // Trigger slightly before element enters viewport
    }
  );

  // Initialize each element with hidden state and observe
  fadeElements.forEach(el => {
    el.classList.add('opacity-0', 'translate-y-4', 'transition-all', 'duration-700', 'ease-out');
    observer.observe(el);
  });
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnimations);
} else {
  initAnimations();
}
